class ReadMore {
    constructor(container)
    {
        this.container = container;
        this.text = container.querySelector('.text');
        this.toggleButton = container.querySelector('.toggle');
        this.readMoreText = container.dataset.readMore;
        this.readLessText = container.dataset.readLess;

        this.init();
    }

    init()
    {
        if (this.toggleButton) {
            this.toggleButton.addEventListener('click', () => this.toggleText());
        }
    }

    toggleText()
    {
        if (this.text.classList.contains('collapsed')) {
            this.text.classList.remove('collapsed');
            this.toggleButton.innerText = this.readLessText;
        } else {
            this.text.classList.add('collapsed');
            this.toggleButton.innerText = this.readMoreText;
        }
    }
}

// initialize for all elements with the class 'read-more'
document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.read-more').forEach(container => {
        new ReadMore(container);
    });
});
